export interface NavItem {
  label:     string
  href:      string
  children?: Array<{ label: string; href: string }>
}

export interface FooterColumn {
  heading: string
  links:   Array<{ label: string; href: string }>
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home',       href: '/' },
  {
    label: 'Apartments', href: '/apartments',
    children: [
      { label: '1-Bedroom Apartments (Sleeps 2)', href: '/apartments/one-bedroom' },
      { label: '3-Bedroom Apartment (Sleeps 6)',  href: '/apartments/three-bedroom' },
    ],
  },
  { label: 'Local Area', href: '/local-area' },
  { label: 'Gallery',    href: '/gallery' },
  { label: 'Reviews',    href: '/reviews' },
  { label: 'About',      href: '/about' },
  { label: 'Contact',    href: '/contact' },
]

export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    heading: 'Accommodation',
    links: [
      { label: 'All Apartments',               href: '/apartments' },
      { label: '1-Bedroom (Sleeps 2)',          href: '/apartments/one-bedroom' },
      { label: '3-Bedroom (Sleeps 6)',          href: '/apartments/three-bedroom' },
      { label: 'Facilities',                    href: '/apartments#facilities' },
      { label: 'Make an Enquiry',               href: '/enquire' },
    ],
  },
  {
    heading: 'Explore',
    links: [
      { label: 'Local Area',                   href: '/local-area' },
      { label: 'Photo Gallery',                href: '/gallery' },
      { label: 'Guest Reviews',                href: '/reviews' },
      { label: 'About Coed y Celyn Hall',      href: '/about' },
    ],
  },
  {
    heading: 'Information',
    links: [
      { label: 'Contact Us',                   href: '/contact' },
      { label: 'How to Find Us',               href: '/contact#find-us' },
      { label: 'Terms & Conditions',           href: '/terms' },
      { label: 'Access Statement',             href: '/access' },
    ],
  },
]
